export const EngineType = {
  HTML5: 'html5',
  FLASH: 'flash',
  SILVERLIGHT: 'silverlight',
  CAST: 'cast',
  YOUTUBE: 'youtube',
  IMAGE: 'image',
  DOCUMENT: 'document'
} as const;
